import React, { useEffect } from 'react';
import { useApi } from '@sdir/httpclient/lib/hooks/useApi';
// eslint-disable-next-line max-len
import { EndorsementServiceFeaturesGetAvailableNationalitiesAvailableNationalitiesDto as NationalitiesDto } from '@sdir/httpclient/lib/clients/aps/endorsement';
import { endorsementApi } from '../../httpclient';
import { asLoadable } from '../../types';
import { NationalitiesContext } from '../../services/contexts/NationalitiesContext';

interface NationalitiesProviderProps {
  children?: any;
}

export const NationalitiesProvider: React.FC<NationalitiesProviderProps> = ({ children }) => {
  const {
    result: nationalities,
    errorObject: nationalitiesError,
    loading: nationalitiesLoading,
    callApi: getNationalities,
  } = useApi({
    apiFunction: () => endorsementApi.getAvailableNationalities(),
  });

  useEffect(() => {
    if (!nationalitiesLoading && !nationalitiesError && !nationalities) getNationalities();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nationalitiesLoading]);

  const value = asLoadable<NationalitiesDto[]>(
    nationalities,
    nationalitiesError,
    nationalitiesLoading
  );

  return <NationalitiesContext.Provider value={value}> {children} </NationalitiesContext.Provider>;
};
